import React from 'react'
import { useNavigate } from 'react-router-dom'
import Module from '../../../../layout/Module'
import AlertSaveButton from '../../../../button/AlertSaveButton'
import { MarkingContextProvider, useMarkingContext } from './MarkingContext/MarkingContext'
import ViewSelector from './ViewSelector/ViewSelector'
import Filters from './Filters/Filters'
import ButtonSave from './ButtonSave/ButtonSave'
import InforMarking from './InfoMarking/InforMarking'
import List from './List/List'
import ButtonAssesmentSetting from './ButtonAssesmentSetting/ButtonAssesmentSetting'
import ButtonDownload from './ButtonDownload/ButtonDownload'

const MarkingHeader = ({ onGoBack }) => {
  const { currentPeriodicalReport } = useMarkingContext()
  const isClosed = currentPeriodicalReport?._id && !currentPeriodicalReport?.isCurrent

  return (
    <Module.BodyHeader className='border-b border-b-2 border-primary justify-between relative'>
      <InforMarking />
      <div
        className='flex gap-2 justify-between items-center absolute top-0 bottom-0px right-4'
        style={{
          left: 'calc(180px + 2.5rem)'
        }}
      >
        <div className='flex gap-2 items-center'>
          <ViewSelector />
          <Filters />
        </div>

        <div className='flex gap-2 items-center justify-end'>
          <ButtonAssesmentSetting />
          <ButtonSave />
          {isClosed && <ButtonDownload />}
          <AlertSaveButton
            submodule='Periodical Report marking'
            icon='times'
            title='Cancel'
            color='primary'
            variant='outlined'
            onDontSave={onGoBack}
          />
        </div>
      </div>
    </Module.BodyHeader>
  )
}

const PeriodicalReportMarking = () => {
  const navigate = useNavigate()

  const goBack = () => {
    navigate(`/dashboard/periodical-report`)
  }

  return (
    <MarkingContextProvider>
      <MarkingHeader onGoBack={goBack} />
      <Module.BodyContainer classNameWrapper='overflow-auto'>
        <List />
      </Module.BodyContainer>
    </MarkingContextProvider>
  )
}

export default PeriodicalReportMarking
